import React, { Component } from 'react';
import classnames from 'classnames';

import { Button, InputLabel, Menu, MenuItem } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { WithStyles, withStyles } from '@mui/styles';
import APMultilevelDropdownStyle from "./styles/APMultilevelDropdown.style";

import { ReactComponent as ChevronDown } from "./assets/icon-chevron-down.svg";
import { ReactComponent as ChevronDownSelected } from "./assets/icon-chevron-down-selected.svg";
import { ReactComponent as ChevronUp } from './assets/icon-chevron-forward.svg';
import { ReactComponent as ChevronUpSelected } from './assets/icon-chevron-forward-selected.svg';
import { ReactComponent as ChevronTick } from './assets/icon-chevron-tick.svg';
import { GroupAffiliateOptions } from "../../../core/types/GeneralTypes";

interface APSubDropdownProps extends WithStyles<typeof APMultilevelDropdownStyle> {
  parentMenuData: GroupAffiliateOptions;
  selectedAffiliateValue: any;
  subOptionSelected: Function,
  selectParentOption: Function,
  isParentValueSelected: boolean,
  isMobileView: boolean
}

class APSubDropdown extends Component<APSubDropdownProps, {}> {
  state = {
    open: false,
    anchorEl: null
  };

  constructor(props: APSubDropdownProps) {
    super(props);
    this.handleSubOptionSelect = this.handleSubOptionSelect.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleMenuButtonClick = this.handleMenuButtonClick.bind(this);
    this.mainMenuClick = this.mainMenuClick.bind(this);
  }

  handleSubOptionSelect = (event: React.MouseEvent<HTMLElement>, selectedOptionObject: GroupAffiliateOptions) => {
    event.stopPropagation();
    this.setState({open:false});
    this.props.subOptionSelected(selectedOptionObject);
  };

  handleMenuClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    this.setState({ anchorEl: null, open: false });
  };

  handleMenuButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget, open: true });
  };

  mainMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    const { isParentValueSelected, selectParentOption } = this.props;
    if (isParentValueSelected) {
      event.stopPropagation();
      selectParentOption(this.props.parentMenuData.value);
    }
  };

  render() {
    const {
      classes,
      selectedAffiliateValue,
      parentMenuData,
      isMobileView
    } = this.props;

    const { subAffiliate, label, value: parentMenuValue } = parentMenuData;
    const { open } = this.state;

    const isCurrentOptionSelected: boolean = selectedAffiliateValue === parentMenuValue;
    const subOptionSelected: boolean = parentMenuData.subAffiliate.find((option: GroupAffiliateOptions) => option.value === selectedAffiliateValue);
    const formControlClass: string = classnames(classes.subMenuFormControlCls, {
      ['menuOpen']: open && !isCurrentOptionSelected
    })

    const parentOptionSelected: boolean = isCurrentOptionSelected || subOptionSelected;
    const DropdownOpenIcon: React.JSX.Element = parentOptionSelected ? <ChevronUpSelected /> : <ChevronUp />;
    const DropdownClosedIcon: React.JSX.Element = parentOptionSelected ? <ChevronDownSelected /> : <ChevronDown />;

    return (
      <FormControl
        className={formControlClass}
        onClick={this.mainMenuClick}
        data-testid="select-subOption-formControl"
      >
        <InputLabel id={`nested-dropdown-label-${label}`}>{label}</InputLabel>
        <Button
          id="subMenu-button"
          data-testid="subMenu-button"
          aria-controls={open ? 'customized-subMenu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          onClick={this.handleMenuButtonClick}
          endIcon={open ? DropdownClosedIcon : DropdownOpenIcon}
          className={classes.subDropdownButton}
          disableRipple
          disableElevation
        />

        <Menu
          id="customized-subMenu"
          elevation={3}
          anchorOrigin={{
            vertical: isMobileView ? 'bottom' : 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: isMobileView ? 'left' : 445,
          }}
          anchorEl={this.state.anchorEl}
          MenuListProps={{
            'aria-labelledby': 'subMenu-button',
          }}
          PaperProps={{
            elevation: 1
          }}
          classes={{
            paper: classes.subMenuPopover
          }}
          open={open}
          onClose={this.handleMenuClose}
        >
          {subAffiliate.map((subOption: GroupAffiliateOptions) => {
            const { value, label } = subOption;
            return (
              <MenuItem
                key={`option-${label}`}
                data-testid="select-subOption"
                value={value}
                className={classes.menuItem}
                onClick={(event: React.MouseEvent<HTMLElement>) => this.handleSubOptionSelect(event, subOption)}
                selected={value === selectedAffiliateValue}
              >
                {label}{value === selectedAffiliateValue ? <ChevronTick className={classes.tickIcon} /> : ''}
              </MenuItem>
            )
          })}
        </Menu>
      </FormControl>
    );
  }
}

export default withStyles(APMultilevelDropdownStyle)(APSubDropdown);
